<script setup>
defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <button :class="{ 'btn-disabled' : disabled || loading }" :disabled="disabled || loading" v-bind="$attrs">
    <LoadingSpinner v-if="loading"/>
    <slot v-else></slot>
  </button>
</template>

<style scoped>

</style>